import React, { useState, useEffect } from "react";
import { BodyText, Heading } from "../../elements";
import api from "../../utils/api";
import { getApiError } from "../../services/siteService";
import ErrorView from "../../sections/error-view";
import "./style.scss";
const DPP = props => {
  console.log("Dpp Props", props);
  const { fields } = props;
  const { consentName } = fields;
  const [contentDetail, setContentDetail] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    api.consent.activated
      .detail(null, {
        consentCode: consentName.value
      })
      .then(res => {
        console.log("consent res", res);
        setContentDetail(res.obj);
      })
      .catch(ex => {
        console.log("exception", ex.code);
        getApiError(ex.code).then(err => {
          setError(err);
        });
      });
  }, [consentName]);
  return (
    <div className="dpp-detail grid">
      {contentDetail && (
        <>
          {/*<Heading className="title" html={{ value: contentDetail.title }} type={{ fields: { phrase: { value: "h2" } } }} />*/}
          <BodyText html={decodeURIComponent(contentDetail.context)} />
        </>
      )}
      <ErrorView {...error} />
    </div>
  );
};
export default DPP;
